import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as FavoriteSelectedIcon } from "assets/images/icons/icn_favorite_selected.svg";
import { ReactComponent as FavoriteUnselectedIcon } from "assets/images/icons/icn_favorite_unselected.svg";
import { CameraStatusIcon } from "./DeviceItem";
import { setCameraDragData } from "../../lib/cameraDrag";

/**
 * FavoriteItem
 * Row in the Favorite section — click to play, drag to assign a grid slot.
 *
 * Props:
 *   device - { id, name, linkStatus? }
 */
const FavoriteItem = ({ device, isFavorited, onPlay, onToggleFavorite }) => {
  const theme = useTheme();
  const [favoriteHover, setFavoriteHover] = useState(false);
  const [isSelected, setIsSelected] = useState(Boolean(isFavorited));
  const online = device?.linkStatus === "online";

  useEffect(() => {
    setIsSelected(Boolean(isFavorited));
  }, [isFavorited]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: "4px",
        py: "2px",
        cursor: onPlay ? "pointer" : "default",
        borderRadius: "4px",
        "&:hover": onPlay ? { backgroundColor: "rgba(23,38,100,0.06)" } : undefined,
      }}
      draggable
      onDragStart={(e) => setCameraDragData(e, device)}
      onClick={() => onPlay?.(device)}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          p: "4px",
          flex: 1,
          minWidth: 0,
        }}
      >
        <CameraStatusIcon online={online} />
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 600,
            color: online ? theme.palette.primary.main : theme.palette.grey[500],
          }}
        >
          {device.name}
        </Typography>
      </Box>

      <IconButton
        size="small"
        disableRipple
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setIsSelected((prev) => !prev);
          onToggleFavorite?.(device.id);
        }}
        onMouseEnter={() => setFavoriteHover(true)}
        onMouseLeave={() => setFavoriteHover(false)}
        sx={{
          p: "4px",
          backgroundColor: favoriteHover ? "rgba(23,38,100,0.08)" : "transparent",
          transition: "all 0.2s",
          borderRadius: "4px",
        }}
      >
        {isSelected ? (
          <FavoriteSelectedIcon width={18} height={18} />
        ) : (
          <FavoriteUnselectedIcon width={18} height={18} style={{ opacity: favoriteHover ? 1 : 0.6 }} />
        )}
      </IconButton>
    </Box>
  );
};

export default FavoriteItem;
